import PropTypes from 'prop-types'
import { useState, useEffect, useCallback } from 'react'
import { toastErrorLog } from '../../helpers/toastErrorLog'
import { useAuth } from '../../hooks/useAuth'
import { withValidador } from '../hoc/withValidador'
import ImagenDni from '../imagen/ImagenDni'
import { Checkbox } from '../reutilizables/checkbox/Checkbox'
import { VincularMercadoPago } from '../reutilizables/pasarelaPagos/VincularMercadoPago'
import * as usuarioService from '../servicios/usuarioService'
import { ModalContenidoTerminos } from '../terminos/ModalContenidoTerminos'
import InputEditable from '../ui/InputEditable'
import ListaOrdenadaEditable from '../ui/ListaOrdenadaEditable'
import DatosFiscales from './DatosFiscales'

const DatosPersonales = (props) => {
  const [datos, setDatos] = useState([])
  const [errores, setErrores] = useState({})
  const [mostrarContenido, setMostrarContenido] = useState(false)
  const { loginDataContext: { idUsuario, tipoUsuario, tipo } = {} } = useAuth()

  const handleClick = () => {
    setMostrarContenido(true)
  }

  const esquema = {
    cuit: props.Validador.Kernel.string()
      .trim()
      .required()
      .error((e) => {
        return props.Validador.mensaje(e, {
          'any.empty': <>El número de CUIT no puede quedar vacío</>
        })
      }),
    email: props.Validador.Kernel.string()
      .trim()
      .required()
      .error((e) => {
        return props.Validador.mensaje(e, {
          'any.empty': <>La dirección de e-mail no puede quedar vacía</>
        })
      }),
    telefono: props.Validador.Kernel.number()
      .empty(0)
      .required()
      .error((e) => {
        return props.Validador.mensaje(e, {
          'any.required': <>El número de teléfono no puede quedar vacío</>
        })
      }),
    celular: props.Validador.Kernel.number()
      .empty(0)
      .required()
      .error((e) => {
        return props.Validador.mensaje(e, {
          'any.required': <>El número de celular no puede quedar vacío</>
        })
      })
  }

  const searchMethod = useCallback(async () => {
    if (!idUsuario) return
    const { data: datos } = await usuarioService.buscarPorId(idUsuario)
    setDatos(datos)
  }, [idUsuario])

  useEffect(() => {
    searchMethod()
  }, [searchMethod])

  useEffect(() => {
    if (props.buscar) {
      searchMethod()
    }
  }, [props.buscar, searchMethod])

  const validarCampo = useCallback(
    (name) => {
      const errores = props.Validador.validarDato(
        esquema,
        {
          cuit: datos.cuit,
          email: datos.email,
          telefono: datos.telefono,
          celular: datos.celular
        },
        name
      )

      setErrores(errores || {})
      if (errores) {
        return false
      } else {
        return true
      }
    },
    [datos, props.Validador, esquema]
  )

  const handleClickOutSide = async (name) => {
    try {
      if (validarCampo(name)) {
        const usuarioDatoNuevo = {
          idUsuario,
          usrId: datos.usrId,
          razonSocial: datos.razonSocial,
          cuit: datos.cuit,
          email: datos.email,
          telefono: datos.telefono,
          celular: datos.celular
        }
        await usuarioService.actualizar(usuarioDatoNuevo)
      }
    } catch (error) {
      const mensaje = `Ocurrió un error al guardar los datos.`
      toastErrorLog(error, mensaje, 'usuario')
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setDatos((prevDatos) => ({
      ...prevDatos,
      [name]: value
    }))
    validarCampo(name)
  }

  return (
    <div className="row mt-4">
      <div className="col-12 col-md">
        <h3>Datos Personales</h3>
        <div className="ml-2">
          <ul>
            <li className="li-datos-perfil disabled">
              <span>Nombre</span>&nbsp;
              <span>{datos.nombre}</span>
            </li>
            <li className="li-datos-perfil disabled">
              <span className="float-left">Apellido</span>&nbsp;
              <span>{datos.apellido}</span>
            </li>
            <li className="li-datos-perfil disabled">
              <span className="float-left">DNI</span>&nbsp;
              <span>{datos.dni}</span>
            </li>
            {tipo === 'P' && (
              <>
                <ImagenDni idUsuario={idUsuario} idTipo={1} download={true}></ImagenDni>
                <ImagenDni idUsuario={idUsuario} idTipo={2} download={true}></ImagenDni>
              </>
            )}
            <li className={`datos-perfil ${tipoUsuario === 'R' ? 'datos-perfil' : 'disabled'}`}>
              <span className="float-left">Empresa</span>&nbsp;
              <InputEditable
                type="text"
                name="razonSocial"
                placeholder=""
                onChange={handleChange}
                texto={datos.razonSocial || ''}
                value={datos.razonSocial}
                classInput="input-editable-perfil"
                classLabel="input-editable-perfil"
                onClickOutSide={handleClickOutSide}
                maxLength={100}
                errores={errores}
              />
            </li>

            <ListaOrdenadaEditable
              type="text"
              name="cuit"
              onChange={handleChange}
              label="Cuit"
              texto={datos.cuit}
              classLista={`datos-perfil ${tipoUsuario === 'R' ? 'datos-perfil' : 'disabled'}`}
              classInput="input-editable-perfil"
              classLabel="input-editable-perfil"
              onClickOutSide={(e, name) => handleClickOutSide(name)}
              value={datos.cuit}
              errores={errores}
            />
          </ul>
        </div>
        <h3>Datos Fiscales</h3>
        <DatosFiscales />
      </div>

      <div className="col-1"></div>
      <div className="col-12 col-md">
        <h3>Datos Usuario</h3>
        <div className="ml-2">
          <ul>
            <li className="li-datos-perfil disabled">
              <span className="spanDatosPersonales">Nombre Usuario</span>
              &nbsp;
              <span className="spanDatosPersonales">{datos.usrId}</span>
            </li>

            <ListaOrdenadaEditable
              type="text"
              name="email"
              onChange={handleChange}
              label="E-mail"
              texto={datos.email}
              classLista={`datos-perfil ${tipoUsuario === 'R' ? 'datos-perfil' : 'disabled'}`}
              classInput="input-editable-perfil"
              classLabel="input-editable-perfil"
              onClickOutSide={(e, name) => handleClickOutSide(name)}
              value={datos.email}
              errores={errores}
            />

            <ListaOrdenadaEditable
              type="text"
              name="telefono"
              label="Teléfono"
              onChange={handleChange}
              texto={datos.telefono}
              classLista={`datos-perfil ${tipoUsuario === 'R' ? 'datos-perfil' : 'disabled'}`}
              classInput="input-editable-perfil"
              classLabel="input-editable-perfil"
              onClickOutSide={(e, name) => handleClickOutSide(name)}
              value={datos.telefono}
              errores={errores}
            />

            <ListaOrdenadaEditable
              type="text"
              name="celular"
              label="Celular"
              onChange={handleChange}
              texto={datos.celular}
              classLista={`datos-perfil ${tipoUsuario === 'R' ? 'datos-perfil' : 'disabled'}`}
              classInput="input-editable-perfil"
              classLabel="input-editable-perfil"
              onClickOutSide={(e, name) => handleClickOutSide(name)}
              value={datos.celular}
              errores={errores}
            />
          </ul>

          <h3>Términos y Condiciones</h3>
          <div className="d-flex align-items-center">
            <Checkbox
              type="checkbox"
              name="aceptaTyC"
              label=" "
              checked={true}
              disabled
              className="mt-1"
            />
            <button onClick={handleClick} className="btn btn-link p-0 align-baseline">
              Ver los términos y condiciones de venta de e-BuyMarket
            </button>
          </div>

          <VincularMercadoPago idUsuario={idUsuario} />
        </div>
      </div>
      <ModalContenidoTerminos
        show={mostrarContenido}
        onCerrar={() => setMostrarContenido(false)}
        soloLectura
      />
    </div>
  )
}

DatosPersonales.propTypes = {
  Validador: PropTypes.shape({
    Kernel: PropTypes.object,
    validarDato: PropTypes.func,
    mensaje: PropTypes.func
  }).isRequired,
  buscar: PropTypes.bool
}

export default withValidador(DatosPersonales)
